import React from 'react'
import './index.scss'
import arrowDown from '../../assets/images/arrow.png'
import arrowGray from '../../assets/images/ic_arrow_gray.png'
import BgModul from '../BgModul/index'
import DefaultSort from '../DefaultSort/index'
import DiscountSort from '../DiscountSort'
import bxlUtils from 'bxl-utils'
import BrandSort from '../BrandSort'
import CategorySort from '../CategorySort'
import { SORTTYPE } from '../DefaultSort'
import MerchantSort from '../MerchantSort'
interface IFilterSearch {
    searchProducts: (q: any) => void
    left: boolean
}
interface IState {
    activeIndex: string | number
    q: {
        s?: string
        discountRange1?: string
        discountRange2?: string
        priceRange1?: string
        priceRange2?: string
        selectBrands?: string[]
        selectCategory?: string
    }
    FILTER: any[]
}
class FilterSearch extends React.Component<IFilterSearch, IState> {
    readonly state: IState = {
        activeIndex: '',
        q: {},
        FILTER: [
            { text: '默认排序', component: DefaultSort },
            { text: '折扣', component: DiscountSort },
            { text: '品牌', component: BrandSort },
            { text: '分类', component: CategorySort },
            { text: '商家', component: MerchantSort }
        ]
    }
    chooseFilterType = index => {
        const { activeIndex, FILTER } = this.state
        this.setState({
            activeIndex: activeIndex === index ? '' : index
        })
    }
    setSearchQuery = (type, value) => {
        const { q, FILTER } = this.state
        if (type === 's') {
            // 排序选择，修改默认值
            let textItem = SORTTYPE.find(item => item.value === value)
            if (textItem) {
                FILTER[0].text = textItem?.label
                this.setState({
                    FILTER
                })
            }
        }
        q[type] = value
        return new Promise((resolve, rejecct) => {
            this.setState(
                {
                    q
                },
                () => {
                    resolve()
                }
            )
        })
    }
    search = () => {
        const { q } = this.state
        const { searchProducts } = this.props
        searchProducts(q)
        this.closeMolul()
    }
    closeMolul = () => {
        this.setState({
            activeIndex: ''
        })
        let node: HTMLDivElement | null = document.querySelector('.App')
        node?.classList.remove('over')
    }
    isSelect = index => {
        const { q } = this.state
        switch (index) {
            case 0:
                if (q.s) return true
                return false
                break
            case 1:
                if (
                    q.discountRange1 ||
                    q.discountRange2 ||
                    q.priceRange1 ||
                    q.priceRange2
                )
                    return true
                return false
                break
            case 2:
                if (q.selectBrands && q.selectBrands.length > 0) return true
                return false
                break
            case 3:
                if (q.selectCategory && q.selectCategory.length > 0) return true
                return false
                break
        }
    }
    render() {
        const { activeIndex, q, FILTER } = this.state
        const Content = FILTER[activeIndex]?.component
        const { left } = this.props
        return (
            <>
                <div className={`filterContent ${left ? 'toLeft' : ''}`}>
                    <div className="filterChoose">
                        {FILTER.map((item, index) => {
                            return (
                                <div
                                    className={`filterItem ${
                                        typeof activeIndex === 'number' &&
                                        +activeIndex === index
                                            ? 'active'
                                            : ''
                                    }`}
                                    key={`filter${index}`}
                                    onClick={() => this.chooseFilterType(index)}
                                >
                                    <span
                                        className={`filterItemText ${
                                            this.isSelect(index) ? 'active' : ''
                                        }`}
                                    >
                                        {item.text}
                                    </span>
                                    <img
                                        src={
                                            (typeof activeIndex === 'number' &&
                                                +activeIndex === index) ||
                                            this.isSelect(index)
                                                ? arrowDown
                                                : arrowGray
                                        }
                                        alt=""
                                    ></img>
                                </div>
                            )
                        })}
                    </div>
                </div>
                {typeof activeIndex === 'number' && (
                    <div className="filterList">
                        <BgModul closeMolul={this.closeMolul}>
                            <Content
                                q={q}
                                setSearchQuery={this.setSearchQuery}
                                searchProducts={this.search}
                            ></Content>
                        </BgModul>
                    </div>
                )}
            </>
        )
    }
}

export default FilterSearch
